export default [
  {
    lang: /^en$/,
    format: "dd-MM-yyyy",
    placeholder: "DD-MM-YYYY"
  },
  {
    lang: /^sv-SE$/,
    format: "yyyy-MM-dd",
    placeholder: "ÅÅÅÅ-MM-DD"
  },
  {
    lang: /^nl-NL$/,
    format: "dd-MM-yyyy",
    placeholder: "DD-MM-YYYY"
  },
  {
    lang: /^fr-FR$/,
    format: "dd-MM-yyyy",
    placeholder: "JJ-MM-AAAA"
  },
  {
    lang: /^es-ES$/,
    format: "dd-MM-yyyy",
    placeholder: "DD-MM-AAAA"
  },
  {
    lang: /^de-DE$/,
    format: "dd-MM-yyyy",
    placeholder: "DD-MM-JJJJ"
  },
  {
    lang: /^it-IT$/,
    format: "dd-MM-yyyy",
    placeholder: "GG-MM-AAAA"
  },
  {
    lang: /^nl-BE$/,
    format: "dd-MM-yyyy",
    placeholder: "DD-MM-JJJJ"
  },
  {
    lang: /^fr-BE$/,
    format: "dd-MM-yyyy",
    placeholder: "JJ-MM-AAAA"
  }
];
